module.exports = __webpack_public_path__ + "img/order-tab-cancelled.46dd2380.png";